import { CircularProgress, Divider } from "@mui/material";
import Styles from "./Pdd.module.css";
import { data, useSearchParams } from "react-router";
import { useEffect, useState } from "react";
import { getPdd } from "../../utils/API/pddMethods";

export default function PddWiev() {
  const [docData, setDocData] = useState({});
  const [params, setParams] = useSearchParams();
  const [pddData, setPddData] = useState({});
  const [loading, setLoading] = useState();

  useEffect(() => {
    setLoading(true);
    !!params.get("theme") &&
      getPdd(params.get("theme")).then(({ data, staus }) => {
        setPddData(data[0]);
        setLoading(false);
      });
  }, [params.get("theme")]);

  return (
    <div style={{ borderRadius: "0.5rem" }} className={Styles.pdd_wiev}>
      {loading ? (
        <CircularProgress
          sx={{ margin: "auto", color: "var(--bckg-accent)" }}
        />
      ) : (
        <>
          <h6>{params.get("name")}</h6>
          <article
            dangerouslySetInnerHTML={{
              __html: pddData
                ? pddData.text
                : `
                    <div
                      style="flex-grow: 1;width: 100%; display: flex; align-items: center; justify-content: center; color:  var(--bckg-accent-lighter);">
                      <p >Текст для данного раздела еще не добавлен</p>
                    </div>`,
            }}></article>
        </>
      )}
    </div>
  );
}
